import React from 'react';
import NavBar from './navBar';
import TittleNavBar from './tittleNavBar';

const PageHeader = ({tittle}) => {
    return (
        <>
        <TittleNavBar/>
        <div>
            <div className="bg-header-background bg-cover"> 
                <div className='bg-pageHeader'>    
                {/* <div className='bg-red-300 sm:bg-blue-300 md:bg-yellow-300 2md:bg-white lg:bg-green-300 2lg:bg-gray-400'> */}
                    <h1 className='text-center w-full animate__animated animate__bounceInLeft font-mono font-semibold text-white lg:text-5xl text-4xl py-[8%]'>{tittle}</h1>
                </div>
            </div>
        </div>
        </>
    );
}
 
export default PageHeader;